export default "__VITE_PUBLIC_ASSET__41beb497__"